import * as Flux from 'dg-web-shared/lib/Flux.tsx';
import { Response } from 'dg-web-shared/lib/HttpResponse.ts';
import { Maybe } from 'dg-web-shared/lib/MaybeV2.ts';
import * as ServerStateSlice from 'dg-web-shared/lib/ServerStateSlice.ts';
import { operatorAppApiUrl } from '../../api/Http.ts';
import * as AsyncRequest from '../../AsyncRequest.ts';
import * as MasterDataZonesState from './MasterDataZonesState.ts';
import * as PermitTypeState from './PermitTypeState.ts';
import * as TariffState from '../../tariffs/state/TariffState.ts';
import * as LocalStorage from 'dg-web-shared/lib/LocalStorage.ts';
import { Items } from 'dg-web-shared/lib/LocalStorage.ts';
import { v1 as uuidv1 } from 'uuid';
import superagent from 'superagent';
import { OperatorLoginData } from './OperatorLoginData.ts';

type Data = Maybe<OperatorLoginData>;

export type State = ServerStateSlice.ServerState<Data>;

export const { get, reset, setResponse } =
    ServerStateSlice.generateServerState<Data>(
        'common-OperatorLogin',
        () => null,
        (store: Flux.Store, state: State) => {
            if (state.shouldFetch) {
                store.update(fetchAccountMeta);
            }
        },
        body => body,
    );

function getOrSetUUID() {
    const token = LocalStorage.getStringItem(Items.deviceUuid);
    if (token) {
        return token;
    }
    const uuid = uuidv1();
    LocalStorage.setStringItem(Items.deviceUuid, uuid);
    return uuid;
}

export const DEVICE_UUID = getOrSetUUID();

const fetchAccountMeta = AsyncRequest.request(
    () =>
        superagent.get(
            operatorAppApiUrl(
                `/operator-logins/current?deviceUuid=${DEVICE_UUID}`,
            ),
        ),
    (store: Flux.Store, res: Response): string => {
        const name = setResponse(store, res);
        store.update(store => {
            MasterDataZonesState.reset(store);
            PermitTypeState.reset(store);
            TariffState.List.reset(store);

            return 'update-after-login';
        });
        return name;
    },
);
